// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_menuIten__selected__OQqAr {
  background-color: #18316e !important;
  color: #fff !important;
}

.styles_button__menu__JzYSp {
  color: #18316e !important;
  border-radius: 8px !important;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/GenericMenu/styles.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,mDAAmD;AACrD","sourcesContent":[".menuIten__selected {\n  background-color: #18316e !important;\n  color: #fff !important;\n}\n\n.button__menu {\n  color: #18316e !important;\n  border-radius: 8px !important;\n  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuIten__selected": `styles_menuIten__selected__OQqAr`,
	"button__menu": `styles_button__menu__JzYSp`
};
export default ___CSS_LOADER_EXPORT___;
